import React from "react";
import { ArrowBackCircle, TrashOutline, AddCircle } from "react-ionicons";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@popperjs/core";
import stylesASAP from "./stylesASAP";
import stylesWMS from "../WMS/stylesWMS";
import _post from "../Functions/Post";
import _postBody from "../Functions/Post";
import constantURI from "../URI";
import ASAPAuthenticate from "../Functions/ASAPAuthenticate";
import stylesMed from "../MedRep/stylesMed";
import { Modal } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import SignaturePad from "react-signature-pad-wrapper";
import Print from "./Print";
import normalizeUnsyncedTransactions from "../Functions/normalizeUnsyncedTransactions";
import { hasPendingCashInvoicePayment } from "../Functions/LoginFlow";

export default class Payment extends React.Component {
  constructor() {
    super();
    this.state = {
      amounts: [],
      authenticate: false,
      token: "",
      loading: true,
      alertUndefined: false,
      paymentTypes: [],
      clientCurrency: [],
      currentCurrency: "",
      primaryRate: "1",
      rates: [],
      invoices: [],
      clientName: "",
      clientId: -1,
      showDeleteAlert: false,
      totalAmount: "",
      currentIndex: -1,
      totalPayment: 0,
      preventSymbols: ["e", "E", "+", "-"],
      isVendor: false,
      paymentId: -1,
      URLs: [{ type: "", clientType: -1 }],
      remainingAmount: 0,
      invalidAmount: false,
      currentType: 3,
      count: 0,
      USP: [],
      originalPayments: [],
      originalCount: [],
      journal: "",
      selectedClient: -1,
      selectedClientName: "",
      showSignatureAlert: false,
      checkSignature: true,
      signature: "",
      user: [],
      dailySummaryReport: [],
      username: "",
      currentCashSales: "",
      cashSalesBody: {},
      cashSalesBodyIndex: 0,
      showPrint: false,
      settingArray: [],
      fixed : 0,
      transactionTypes: [
        {
          id: 0,
          name: "Order",
          SOs: "CreateSO?token=",
          type: "SAL",
          LS: "SO",
          signature: "updateSO?token=",
        },
        {
          id: 1,
          name: "Return",
          SOs: "CreateSO?token=",
          type: "RO",
          LS: "Return",
          signature: "updateSO?token=",
        },
        {
          id: 2,
          name: "Purchase",
          SOs: "CreatePO?token=",
          type: "RFQ",
          LS: "PO",
          signature: "updatePO?token=",
        },
        {
          id: 3,
          name: "Invoices",
          signature: "updateInvoice?token=",
          backButton: "Receipt",
        },
        {
          id: 4,
          name: "Delivery",
          SOs: "CreateSO?token=",
          type: "DLV",
          LS: "Delivery",
          signature: "updateSO?token=",
        },
        {
          id: 5,
          name: "CashSales",
          SOs: "CreateSO?token=",
          type: "",
          LS: "SO",
          signature: "updateSO?token=",
          backButton: "CashSales",
        },
      ],
    };
    this.sign = React.createRef();
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";

    //Check internet connectivity
    // A pending cash-sale lock always pays a cash sale, even if another screen
    // changed TransactionType before the app redirected here.
    const type = hasPendingCashInvoicePayment()
      ? 5
      : JSON.parse(localStorage.getItem("TransactionType"));
    const currentCashSales = JSON.parse(
      localStorage.getItem("CurrentCashSales")
    );
    const token = JSON.parse(localStorage.getItem("Token"));
    const client = JSON.parse(localStorage.getItem("SelectedClientDetails"));
    const pendingInvoices = JSON.parse(localStorage.getItem("PendingInvoices"));
    const dailySummaryReport = JSON.parse(
      localStorage.getItem("DailySummaryReport")
    );
    const user = JSON.parse(localStorage.getItem("User"));
    const isVendor = JSON.parse(localStorage.getItem("isVendor"));
    const username = JSON.parse(localStorage.getItem("Username"));
    const clientName = JSON.parse(localStorage.getItem("SelectedClientName"));
    const total = JSON.parse(localStorage.getItem("Total"));
    const CurrencyRate = JSON.parse(localStorage.getItem("CurrencyRate"));
    const settingArray = JSON.parse(localStorage.getItem("SettingArray") || "[]");
    const normalizedCurrencyRate = Array.isArray(CurrencyRate) ? CurrencyRate : [];

    await this.setState({
      currentCashSales: currentCashSales,
      CurrencyRate: normalizedCurrencyRate,
      currentType: type,
      token: token,
      username: username,
      clientCurrency: client?.currency_id || [],
      selectedClient: client?.id ?? -1,
      balance: client?.balance ?? 0,
      credit_limit: client?.credit_limit ?? 0,
      user: user,
      selectedClientName: client?.name || "",
      invoices: pendingInvoices || [],
      isVendor: isVendor,
      settingArray: Array.isArray(settingArray) ? settingArray : [],
      dailySummaryReport:
        Array.isArray(dailySummaryReport) && dailySummaryReport.length > 0
          ? dailySummaryReport
          : [
              {
                ordered: 0,
                visited: 0,
                collection: 0,
                OOR: 0,
              },
            ],
    });
    const precisionValue = Number(
      Array.isArray(settingArray)
        ? settingArray.find((item) => item.key === "PricesDigitPrecesion")?.value
        : undefined
    );
    if (Number.isFinite(precisionValue) && precisionValue >= 0) {
      this.setState({ fixed: precisionValue });
    } else {
      this.setState({ fixed: 2 });
    }
    //Setting Data from local storage
    const { counts: count, transactions: payments } =
      normalizeUnsyncedTransactions();

    await this.setState({
      count:
        count.length !== 0 && count[this.state.currentType] !== undefined
          ? count[this.state.currentType]
          : 0,
      USP:
        payments.length !== 0 &&
        payments[this.state.currentType] !== undefined &&
        payments[this.state.currentType] !== null
          ? payments[this.state.currentType]
          : [],
      originalPayments: payments,
      originalCount: count,
    });

    const matchesCashSalesIdentity = (item, invoiceName) => {
      const normalizedInvoiceName =
        typeof invoiceName === "string" ? invoiceName.trim() : invoiceName;
      if (
        normalizedInvoiceName === null ||
        normalizedInvoiceName === undefined ||
        normalizedInvoiceName === "" ||
        normalizedInvoiceName === "undefined" ||
        normalizedInvoiceName === "null"
      ) {
        return false;
      }

      const candidateValues = [
        item?.name,
        item?.Body?.name,
        item?.Body?.invoice_name,
        item?.Body?.cashInvoiceName,
        item?.Body?.cash_invoice_name,
        item?.id,
        item?.usId,
      ];

      return candidateValues.some((value) => {
        if (value === null || value === undefined) return false;
        const normalizedValue = typeof value === "string" ? value.trim() : value;
        return normalizedValue === normalizedInvoiceName || Number(normalizedValue) === Number(normalizedInvoiceName);
      });
    };

    const matchingCashSales = this.state.USP.filter((item) =>
      matchesCashSalesIdentity(item, this.state.currentCashSales)
    );
    const currentPayment =
      matchingCashSales[0] ||
      (this.state.USP.length === 1 ? this.state.USP[0] : null);
    const currentPaymentIndex = currentPayment
      ? this.state.USP.findIndex((item) =>
          matchesCashSalesIdentity(item, currentPayment?.name || currentPayment?.Body?.invoice_name || currentPayment?.Body?.cashInvoiceName || currentPayment?.Body?.cash_invoice_name || currentPayment?.id || currentPayment?.usId)
        )
      : -1;

    const normalizedCashSalesBody =
      currentPayment && typeof currentPayment === "object"
        ? currentPayment
        : { Body: {} };

    if (!normalizedCashSalesBody.Body || typeof normalizedCashSalesBody.Body !== "object") {
      normalizedCashSalesBody.Body = {};
    }

    this.setState({
      cashSalesBody: normalizedCashSalesBody,
      cashSalesBodyIndex: currentPaymentIndex >= 0 ? currentPaymentIndex : this.state.USP.length === 1 ? 0 : -1,
      currentCurrency: this.getCurrentPaymentCurrency(),
    });

    //Get Client's name and how much did he pay
    if (this.state.currentType === 3) {
      this.getClientNameAndAmount();
    } else {
      this.setState({ clientName: clientName, totalAmount: Number(total).toFixed(this.state.fixed) });
    }
    //Check if selected client is customer or vendor (Receipt or Payment)
    if (isVendor) {
      await this.setState({ ...(this.state.URLs[0].clientType = 3) });
    } else {
      await this.setState({ ...(this.state.URLs[0].clientType = 1) });
    }

    const getPaymentType =
      constantURI() +
      "GetPaymentType?token=" +
      this.state.token +
      "&user=" +
      this.state.username;
    const getRate =
      constantURI() +
      "GetRate?token=" +
      this.state.token +
      "&user=" +
      this.state.username;

    //If online
    // if (this.state.authenticate) {
    //     //Get PaymentTypes based on client
    //     await _post(getPaymentType).then((response) => {
    //         return response.json().then((data) => {
    //             if (data.result !== undefined) {
    //                 this.setState({ paymentTypes: data.result })
    //                 localStorage.setItem('PaymentTypes', JSON.stringify(this.state.paymentTypes));
    //             } else {
    //                 this.setState({ alertUndefined: true });
    //             }
    //         })
    //     });
    //     //Get rates
    //     await _post(getRate).then((response) => {
    //         return response.json().then((data) => {
    //             if (data.result !== undefined) {
    //                 this.setState({ rates: data.result, loading: false })
    //                 localStorage.setItem('Rates', JSON.stringify(this.state.rates));
    //             } else {
    //                 this.setState({ alertUndefined: true });
    //             }
    //         })
    //     })
    // }
    //If offline

    const journals = JSON.parse(localStorage.getItem("Journals") || "[]");
    const PaymentTypes = JSON.parse(localStorage.getItem("PaymentTypes") || "[]");
    const rates = JSON.parse(localStorage.getItem("Rates") || "[]");
    this.setState({
      journals: Array.isArray(journals) ? journals : [],
      rates: Array.isArray(rates) ? rates : [],
      paymentTypes: Array.isArray(PaymentTypes) ? PaymentTypes : [],
      loading: false,
    });

    await this.setRates();
    await this.setPaymentTypeBeginning();
    await this.getCurrencyRate();
  }
  getCurrencyRate = () => {
    const safeCurrencyRates = Array.isArray(this.state.CurrencyRate)
      ? this.state.CurrencyRate
      : [];
    const temp = safeCurrencyRates.filter((rate) => rate?.CurrencyCode === "LBP");
    this.setState({ CurrencyRate: temp });
  };
  showPrint = () => {
    this.setState({ showPrint: true });
  };

  closePrint = () => {
    this.setState({ showPrint: false });
  };
  //Get the client's name and the amount paid based on the selected invoices in the previous page
  getClientNameAndAmount = async () => {
    var total = 0;
    var name = "";
    var id = -1;
    await this.state.invoices.map((item) => {
      if (item.amountToPay !== undefined) total += Number(item.amountToPay);
      name = item.partner_id[1];
      id = item.partner_id[0];
    });
    this.setState({ clientName: name, totalAmount: total.toFixed(this.state.fixed), clientId: id });
  };


  getCurrencyTupleFromValue = (currencyValue) => {
    if (!currencyValue) return null;

    if (Array.isArray(currencyValue) && currencyValue.length > 1) {
      return [currencyValue[0], currencyValue[1]];
    }

    if (typeof currencyValue === "string") {
      currencyValue = JSON.parse(currencyValue.trim());
    }

    if (currencyValue && typeof currencyValue === "object") {
      if (Array.isArray(currencyValue.currency_id) && currencyValue.currency_id.length > 1) {
        return [currencyValue.currency_id[0], currencyValue.currency_id[1]];
      }
      if (currencyValue.id !== undefined && (currencyValue.name !== undefined || currencyValue.code !== undefined)) {
        return [currencyValue.id, currencyValue.name || currencyValue.code];
      }
      if (currencyValue[0] !== undefined && currencyValue[1] !== undefined) {
        return [currencyValue[0], currencyValue[1]];
      }
    }

    return null;
  };

  normalizeCurrency = (currencyValue) => {
    return this.getCurrencyTupleFromValue(currencyValue);
  };

  getCurrentPaymentCurrency = () => {
    const orderedCurrencyValues = [
      [localStorage.getItem("DefaultCurrencyId"), localStorage.getItem("DefaultCurrencyName")],
      this.state.clientCurrency,
    ];

    for (const currencyValue of orderedCurrencyValues) {
      const normalized = this.normalizeCurrency(currencyValue);
      if (normalized) {
        return normalized;
      }
    }

    return [];
  };

  getCurrencyDisplayName = (currencyValue) => {
    const normalized = this.normalizeCurrency(currencyValue);
    if (Array.isArray(normalized)) {
      return String(normalized[1] ?? normalized[0] ?? "").trim();
    }
    if (typeof currencyValue === "string") {
      return currencyValue.trim();
    }
    if (currencyValue && typeof currencyValue === "object") {
      return String(
        currencyValue.name || currencyValue.code || currencyValue.label || "",
      ).trim();
    }
    return "";
  };

  //Set the primary rate based on the selected payment currency
  setRates = () => {
    const paymentCurrency = this.getCurrentPaymentCurrency();
    const safeRates = Array.isArray(this.state.rates) ? this.state.rates : [];
    let isFound = false;
    safeRates.some((rate) => {
      if (rate && rate.currency_id && rate.currency_id[0] === paymentCurrency[0] && !isFound) {
        this.setState({ primaryRate: rate.rate });
        isFound = true;
      }
      return isFound;
    });
    if (!isFound) {
      this.setState({ primaryRate: "1" });
    }
  };

  onSelectType = (index) => async (e) => {
    const selectedValue = Number(e.target.value);
    const paymentType = this.state.paymentTypes.find(
      (item) => item.id === selectedValue
    );
    const nextAmounts = [...this.state.amounts];
    const currentEntry = nextAmounts[index] || {};
    const selectedCurrencyId = paymentType?.currency_id ?? currentEntry.currenyId;
    const selectedRate =
      Array.isArray(this.state.rates) && this.state.rates.length > 0
        ? this.state.rates.find(
            (item) => item?.currency_id?.[0] === selectedCurrencyId?.[0]
          )?.rate || 1
        : 1;

    nextAmounts[index] = {
      ...currentEntry,
      payType: selectedValue,
      amount: 0,
      convertedAmount: 0,
      currenyId: selectedCurrencyId,
      paymentType: paymentType?.paymentType ?? currentEntry.paymentType,
      type: paymentType?.name ?? currentEntry.type,
      rate: selectedRate,
    };

    await this.setState({ amounts: nextAmounts });
    await this.calculateRemainingAmountPrimaryCurrency();
    await this.calculateRemainingAmountSelectedCurrency(index);
  };

  onChangeAmount = (index) => async (e) => {
    const enteredAmount = Number(e.target.value);
    const currentEntry = this.state.amounts[index] || {};
    const rate = Number(currentEntry.rate || this.state.primaryRate || 1);
    const convertedAmount = Number(
      ((enteredAmount / rate) * Number(this.state.primaryRate || 1)).toFixed(
        this.state.fixed
      )
    );
    const nextAmounts = [...this.state.amounts];

    if (convertedAmount <= Number(this.state.totalAmount || 0)) {
      nextAmounts[index] = {
        ...currentEntry,
        amount: enteredAmount,
        convertedAmount,
      };

      await this.setState({ amounts: nextAmounts });
      await this.setTotalPaymentAmount();
      await this.calculateRemainingAmountPrimaryCurrency();
    }

    if (this.state.invalidAmount) {
      const previousAmount = Number(currentEntry.amount || 0);
      const previousConverted = Number(currentEntry.convertedAmount || 0);
      nextAmounts[index] = {
        ...currentEntry,
        amount: previousAmount - enteredAmount,
        convertedAmount: previousConverted - convertedAmount,
      };

      await this.setState({ amounts: nextAmounts });
      await this.setTotalPaymentAmount();
      await this.calculateRemainingAmountPrimaryCurrency();
    }
  };

  setTotalPaymentAmount = async () => {
    var total = 0;
    await this.state.amounts.map((item) => {
      if (item !== undefined && item.convertedAmount !== undefined)
        total += Number(item.convertedAmount);
    });
    await this.setState({ totalPayment: total });
    await localStorage.setItem("amount", JSON.stringify(this.state.amounts));
  };

  //Set the first payment method to the client's currency and put the default amount to the total paid amount
  setPaymentTypeBeginning = async () => {
    const paymentCurrency = this.getCurrentPaymentCurrency();
    const safePaymentTypes = Array.isArray(this.state.paymentTypes)
      ? this.state.paymentTypes
      : [];

    if (safePaymentTypes.length === 0) {
      this.setState({ amounts: [], totalPayment: 0 });
      return;
    }

    const preferredPaymentType = safePaymentTypes.find(
      (item) => item && item.currency_id && item.currency_id[0] === paymentCurrency[0]
    ) || safePaymentTypes[0];

    if (!preferredPaymentType) {
      this.setState({ amounts: [], totalPayment: 0 });
      return;
    }

    const nextAmounts = [
      {
        payType: preferredPaymentType.id,
        currenyId: preferredPaymentType.currency_id,
        amount: Number(this.state.totalAmount || 0),
        rate: this.state.primaryRate || 1,
        paymentType: preferredPaymentType.paymentType,
        type: preferredPaymentType.name,
        convertedAmount: Number(this.state.totalAmount || 0),
      },
    ];

    this.setState({ amounts: nextAmounts, totalPayment: Number(this.state.totalAmount || 0) });
    await localStorage.setItem("amount", JSON.stringify(nextAmounts));
  };

  incrementLastReceiptNumber = async () => {
    const nextUser = Array.isArray(this.state.user) ? [...this.state.user] : [];
    if (nextUser[0] && typeof nextUser[0] === "object") {
      nextUser[0] = {
        ...nextUser[0],
        last_receipt_number: Number(nextUser[0].last_receipt_number || 0) + 1,
      };
    }
    await this.setState({ user: nextUser });
    localStorage.setItem("User", JSON.stringify(nextUser));
  };

  saveOnline = async (createReceipt, receiptUUID) => {
    this.setState({ loading: true });
    var body = {};
    var temp = [];
    await this.state.amounts.map((item, index) => {
      temp[index] = {};
      temp[index].amount = item.amount;
      temp[index].receipt_amount = item.convertedAmount;
      temp[index].currency_id = item.currenyId[0];
      temp[index].payment_type_id = item.payType;
      temp[index].receiptNum = "RCT-" + receiptUUID;
    });
    body.lines = temp;

    await _postBody(createReceipt, body).then((response) => {
      return response.json().then(async (data) => {
        if (data.result === undefined) alert("Please try again");
        else {
          await this.setState({ paymentId: data.result });
          const updateSignature =
            constantURI() +
            "UpdateReceipt?token=" +
            this.state.token +
            "&user=" +
            this.state.username +
            "&id=" +
            this.state.paymentId;
          var body = {};
          body.signature = this.state.signature.substring(22);
          await _postBody(updateSignature, body);
          const updateUser =
            constantURI() +
            "UpdateUser?token=" +
            this.state.token +
            "&user=" +
            this.state.username +
            "&userId=" +
            this.state.user[0].id +
            "&LastReceiptNum=" +
            (Number(this.state.user[0].last_receipt_number) + 1);
          await _post(updateUser);
          console.log(updateUser);
          this.incrementLastReceiptNumber();
        }
      });
    });
    await this.state.invoices.map(async (invoice, index, array) => {
      const createReceiptInvoices =
        constantURI() +
        "CreateTransReceipt?token=" +
        this.state.token +
        "&user=" +
        this.state.username +
        "&moveId=" +
        invoice.id +
        "&paymentId=" +
        this.state.paymentId +
        "&amount=" +
        invoice.amountToPay;
      const updateInvoice =
        constantURI() +
        "UpdateInvoice?token=" +
        this.state.token +
        "&user=" +
        this.state.username +
        "&id=" +
        invoice.id +
        "&amount=" +
        (invoice.amount_total - invoice.amount_residual + invoice.amountToPay);
      await _post(createReceiptInvoices).then((response) => {
        return response.json().then(async (data) => {
          if (data.result === undefined) alert("Please try again");
          else {
            console.log(data.result);
          }
        });
      });
      await _post(updateInvoice).then((response) => {
        return response.json().then(async (data) => {
          if (data.result === undefined) alert("Please try again");
          else {
            console.log(data.result);
          }
        });
      });
      if (index === array.length - 1) {
        localStorage.setItem("PendingInvoices", JSON.stringify([]));
        this.props.history.push("./Receipt");
      }
    });
    //Not needed FOR NOW
    //await this.state.amounts.map(async (amount) => {
    //    const createReceiptLines = constantURI() + "CreateReceiptLines?token=" + this.state.token+ "&user=" + this.state.username + "&amount=" + amount.amount + "&paymentId=" + this.state.paymentId +
    //        "&account=" + amount.accountId + "&method=" + Number(amount.payType) + "&type=" + amount.paymentType + "&currency=" + amount.currenyId[0];
    //    console.log(createReceiptLines)
    //    await _post(createReceiptLines);
    //});
  };

  clearPendingCashInvoicePayment = () => {
    try {
      localStorage.removeItem("PendingCashInvoicePayment");
      localStorage.removeItem("CurrentCashSales");
    } catch (error) {
      // Ignore storage errors in restricted browser contexts.
    }
  };

  safeNavigateAfterPayment = (targetPath = "/CashSales") => {
    try {
      if (this.props && this.props.history && typeof this.props.history.push === "function") {
        this.props.history.push(targetPath);
        return;
      }
    } catch (error) {
      // fall through to browser navigation
    }

    if (typeof window !== "undefined") {
      window.location.assign(targetPath);
    }
  };

  saveOfflineCashInvoice = async () => {
    var tempBody = [];
    const setting = this.state.settingArray.find(
      (url) => url.key === "OnAccountPaymentTypeId"
    );

    const value = setting ? setting.value : null;

    const filtered = this.state.amounts.filter(
      (x) => x.payType === parseInt(value)
    );
    const total = {
      sum: filtered.reduce((sum, x) => sum + x.amount, 0),
      payType: filtered.length > 0 ? filtered[0].payType : null,
    };
    // const unsyncedTotal = this.state.UnsyncedTransactions?.[5]?.Body?.cashPayment
    // ?.filter((payment) => payment.payType === parseInt(value))
    // ?.reduce((sum, payment) => sum + payment.amount, 0) || 0;
    const originalPaymentsByType = Array.isArray(this.state.originalPayments)
      ? this.state.originalPayments
      : [];
    const cashSalesPaymentsForType = Array.isArray(originalPaymentsByType[5])
      ? originalPaymentsByType[5]
      : [];
    const unsyncedTotal = cashSalesPaymentsForType.reduce((total, pay) => {
      const cashPayments = Array.isArray(pay?.Body?.cashPayment)
        ? pay.Body.cashPayment
        : [];
      const matched = cashPayments.filter((payment) => payment.payment_type_id === 3);
      return total + matched.reduce((sum, payment) => sum + Number(payment.amount || 0), 0);
    }, 0);

    const usp = Array.isArray(this.state.USP) ? this.state.USP : [];
    const originalPayments = Array.isArray(this.state.originalPayments)
      ? this.state.originalPayments
      : [];
    const cashSalesBody = this.state.cashSalesBody && typeof this.state.cashSalesBody === "object"
      ? this.state.cashSalesBody
      : { Body: {} };

    if (!cashSalesBody.Body || typeof cashSalesBody.Body !== "object") {
      cashSalesBody.Body = {};
    }

    this.state.cashSalesBody = cashSalesBody;

    const matchesCashSalesIdentity = (item, invoiceName) => {
      const normalizedInvoiceName =
        typeof invoiceName === "string" ? invoiceName.trim() : invoiceName;
      if (
        normalizedInvoiceName === null ||
        normalizedInvoiceName === undefined ||
        normalizedInvoiceName === "" ||
        normalizedInvoiceName === "undefined" ||
        normalizedInvoiceName === "null"
      ) {
        return false;
      }

      const candidateValues = [
        item?.name,
        item?.Body?.name,
        item?.Body?.invoice_name,
        item?.Body?.cashInvoiceName,
        item?.Body?.cash_invoice_name,
        item?.id,
        item?.usId,
      ];

      return candidateValues.some((value) => {
        if (value === null || value === undefined) return false;
        const normalizedValue = typeof value === "string" ? value.trim() : value;
        return normalizedValue === normalizedInvoiceName || Number(normalizedValue) === Number(normalizedInvoiceName);
      });
    };

    const persistCashSalesPayment = () => {
      const activeInvoiceName =
        this.state.currentCashSales ||
        cashSalesBody?.name ||
        cashSalesBody?.Body?.invoice_name ||
        cashSalesBody?.Body?.cashInvoiceName ||
        cashSalesBody?.Body?.cash_invoice_name;

      const hasExactActiveInvoice =
        activeInvoiceName === undefined || activeInvoiceName === null || activeInvoiceName === ""
          ? usp.length === 1
          : usp.some((item) => matchesCashSalesIdentity(item, activeInvoiceName));

      const invoiceName =
        this.state.currentCashSales ||
        cashSalesBody?.name ||
        cashSalesBody?.Body?.invoice_name ||
        cashSalesBody?.Body?.cashInvoiceName ||
        `CSH-${this.state.count + 1}`;

      const shouldCreateNewInvoice = usp.length > 1 && !hasExactActiveInvoice;
      const targetIndex = Number.isInteger(this.state.cashSalesBodyIndex)
        ? this.state.cashSalesBodyIndex
        : -1;

      const preparedCashBody = {
        name: invoiceName,
        usId: this.state.count,
        Body: {
          invoice_name: cashSalesBody?.Body?.invoice_name || invoiceName,
          cashInvoiceName: cashSalesBody?.Body?.cashInvoiceName || invoiceName,
          cashPayment: tempBody,
        },
      };

      if (shouldCreateNewInvoice) {
        usp.push(preparedCashBody);
        originalPayments[this.state.currentType] = usp;
        this.state.USP = usp;
        this.state.originalPayments = originalPayments;
        localStorage.setItem("UnsyncedTransactions", JSON.stringify(originalPayments));
        localStorage.setItem("CurrentCashSales", JSON.stringify(invoiceName));
        this.clearPendingCashInvoicePayment();
      this.safeNavigateAfterPayment("/CashSales");
      return;
      }

      if (targetIndex < 0) {
        usp.push(preparedCashBody);
        originalPayments[this.state.currentType] = usp;
        this.state.USP = usp;
        this.state.originalPayments = originalPayments;
        localStorage.setItem("UnsyncedTransactions", JSON.stringify(originalPayments));
        localStorage.setItem("CurrentCashSales", JSON.stringify(invoiceName));
        this.clearPendingCashInvoicePayment();
        this.safeNavigateAfterPayment("/CashSales");
        return;
      }

      cashSalesBody.name = invoiceName;
      cashSalesBody.Body.invoice_name = cashSalesBody.Body.invoice_name || invoiceName;
      cashSalesBody.Body.cashInvoiceName = cashSalesBody.Body.cashInvoiceName || invoiceName;
      cashSalesBody.usId = this.state.count;
      cashSalesBody.Body.cashPayment = tempBody;
      this.state.cashSalesBody = cashSalesBody;
      usp[targetIndex] = cashSalesBody;
      originalPayments[this.state.currentType] = usp;
      this.state.USP = usp;
      this.state.originalPayments = originalPayments;
      localStorage.setItem(
        "UnsyncedTransactions",
        JSON.stringify(originalPayments)
      );
      this.clearPendingCashInvoicePayment();
      this.safeNavigateAfterPayment("/CashSales");
    };

    const buildPaymentItems = () => {
      for (const amount of this.state.amounts || []) {
        if (amount.amount !== 0 && amount.amount !== undefined) {
          const tempItem = {
            amount: amount.amount,
            receipt_amount: amount.convertedAmount,
            currency_id: amount.currenyId && amount.currenyId[0],
            payment_type_id: amount.payType,
            payment_type: amount.paymentType,
          };

          tempBody.push(tempItem);
        }
      }
    };

    if (total.payType === parseInt(value)) {
      if (
        this.state.balance + total.sum + unsyncedTotal <
        this.state.credit_limit
      ) {
        buildPaymentItems();
        persistCashSalesPayment();
      } else {
        alert("the ammount is greater than the credite limits");
      }
    } else {
      buildPaymentItems();
      persistCashSalesPayment();
    }

    // if (this.state.amounts.length !== 0) {
    //   await this.state.amounts.map(async(amount) => {
    //     if (amount.amount !== 0 && amount.amount !== undefined) {
    //       var tempItem = {}; //The body to send to the api

    //       tempItem.amount = amount.amount;
    //       tempItem.receipt_amount = amount.convertedAmount;
    //       tempItem.currency_id = amount.currenyId[0];
    //       tempItem.payment_type_id = amount.payType;
    //       tempItem.payment_type = amount.paymentType;

    //       tempBody.push(tempItem);
    //     }
    //   });
    // }
    // this.state.cashSalesBody.Body.cashPayment = tempBody;
    // this.state.USP[this.state.cashSalesBodyIndex] = this.state.cashSalesBody;
    // this.state.originalPayments[this.state.currentType] = this.state.USP;
    // localStorage.setItem(
    //   "UnsyncedTransactions",
    //   JSON.stringify(this.state.originalPayments)
    // );
    // await this.showPrint();

    // this.props.history.push(
    //   "./" + this.state.transactionTypes[this.state.currentType].backButton
    // );
  };

  // saveOfflineInvoice = async (createReceipt, receiptUUID) => {
  //   var payments = this.state.USP === null ? [] : this.state.USP;
  //   var uuid = uuidv4();

  //   //Define the header of the Payment
  //   var temp = {};
  //   temp.createURL = createReceipt;
  //   temp.usId = this.state.count;
  //   temp.name = "CSH" + (this.state.count + 1);
  //   temp.amount_total = this.state.totalAmount;
  //   temp.amount_residual = this.state.remainingAmount.toFixed(this.state.fixed);
  //   temp.invoice_date = new Date().toISOString().substring(0, 10);
  //   temp.partner_id = [];
  //   temp.partner_id[0] = this.state.selectedClient;
  //   temp.partner_id[1] = this.state.selectedClientName;
  //   temp.state = "Unsynced";
  //   temp.signatureUrl =
  //     constantURI() +
  //     "UpdateReceipt?token=" +
  //     this.state.token +
  //     "&user=" +
  //     this.state.username +
  //     "&id=" +
  //     uuid;
  //   temp.userUrl =
  //     constantURI() +
  //     "UpdateUser?token=" +
  //     this.state.token +
  //     "&user=" +
  //     this.state.username +
  //     "&userId=" +
  //     this.state.user[0].id +
  //     "&LastReceiptNum=" +
  //     (Number(this.state.user[0].last_receipt_number) + 1);
  //   temp.signature = this.state.signature.substring(22);
  //   this.incrementLastReceiptNumber();
  //   //Define the lines of the transaction
  //   temp.Lines = [];
  //   var tempBody = {
  //     lines: [],
  //   };
  //   if (this.state.amounts.length !== 0) {
  //     await this.state.amounts.map((amount) => {
  //       if (amount.amount !== 0 && amount.amount !== undefined) {
  //         var tempLine = {}; //The details to use in details page
  //         var tempItem = {}; //The body to send to the api
  //         const createReceiptLines =
  //           constantURI() +
  //           "CreateReceiptLines?token=" +
  //           this.state.token +
  //           "&user=" +
  //           this.state.username +
  //           "&amount=" +
  //           amount.amount +
  //           "&paymentId=" +
  //           uuid +
  //           "&account=" +
  //           amount.accountId +
  //           "&method=" +
  //           Number(amount.payType) +
  //           "&type=" +
  //           amount.paymentType +
  //           "&currency=" +
  //           amount.currenyId[0];

  //         tempItem.amount = amount.amount;
  //         tempItem.receiptNum = "RCT-" + receiptUUID;
  //         tempItem.receipt_amount = amount.convertedAmount;
  //         tempItem.currency_id = amount.currenyId[0];
  //         tempItem.payment_type_id = amount.payType;

  //         tempLine = amount;
  //         tempLine.id = uuid;
  //         tempLine.URL = createReceiptLines;

  //         temp.Lines.push(tempLine);
  //         tempBody.lines.push(tempItem);
  //       }
  //     });
  //   }
  //   temp.Body = tempBody;

  //   //Define the invoices of the transaction
  //   temp.Invoices = [];
  //   if (this.state.invoices.length !== 0) {
  //     await this.state.invoices.map((invoice) => {
  //       var tempLine = {};
  //       const createReceiptInvoices =
  //         constantURI() +
  //         "CreateTransReceipt?token=" +
  //         this.state.token +
  //         "&user=" +
  //         this.state.username +
  //         "&moveId=" +
  //         invoice.id +
  //         "&amount=" +
  //         invoice.amountToPay +
  //         "&paymentId=" +
  //         uuid;
  //       const updateInvoice =
  //         constantURI() +
  //         "UpdateInvoice?token=" +
  //         this.state.token +
  //         "&user=" +
  //         this.state.username +
  //         "&id=" +
  //         invoice.id +
  //         "&amount=" +
  //         (invoice.amount_total -
  //           invoice.amount_residual +
  //           Number(invoice.amountToPay));
  //       tempLine = invoice;
  //       tempLine.id = uuid;
  //       tempLine.URL = createReceiptInvoices;
  //       tempLine.UpdateURL = updateInvoice;

  //       temp.Invoices.push(tempLine);
  //     });
  //   }
  //   //Set this transaction and the count in the local storage
  //   await payments.push(temp);
  //   this.setState({ count: this.state.count + 1 });
  //   const localCount = this.state.originalCount;
  //   localCount[this.state.currentType] = this.state.count;
  //   const localSOs = this.state.originalPayments;
  //   localSOs[this.state.currentType] = payments;
  //   await localStorage.setItem(
  //     "UnsyncedTransactionsCount",
  //     JSON.stringify(localCount)
  //   );
  //   await localStorage.setItem(
  //     "UnsyncedTransactions",
  //     JSON.stringify(localSOs)
  //   );
  //   await this.DailySummaryReport();
  //   // await this.showPrint();
  //   await this.props.history.push("/Receipt");
  // };

   saveOfflineInvoice = async (createReceipt) => {
     var uuid = uuidv4();
     var temp = {};
    var payments = this.state.USP === null ? [] : this.state.USP;
   

    //Define the header of the Payment
    
    temp.createURL = createReceipt;
    temp.usId = this.state.count;
    temp.name = "CSH" + (this.state.count + 1);
    temp.amount_total = this.state.totalAmount;
    temp.amount_residual = this.state.remainingAmount.toFixed(this.state.fixed);
    temp.invoice_date = new Date().toISOString().substring(0, 10);
    temp.partner_id = [];
    temp.partner_id[0] = this.state.selectedClient;
    temp.partner_id[1] = this.state.selectedClientName;
    temp.state = "Unsynced";
    temp.signatureUrl =
      constantURI() +
      "UpdateReceipt?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&id=" +
      uuid;
    temp.userUrl =
      constantURI() +
      "UpdateUser?token=" +
      this.state.token +
      "&user=" +
      this.state.username +
      "&userId=" +
      this.state.user[0].id +
      "&LastReceiptNum=" +
      (Number(this.state.user[0].last_receipt_number) + 1);
    temp.signature = this.state.signature.substring(22);
    this.incrementLastReceiptNumber();
    //Define the lines of the transaction
    temp.Lines = [];
    var tempBody = {
      lines: [],
    };
    if (this.state.amounts.length !== 0) {
      await this.state.amounts.map((amount) => {
        if (amount.amount !== 0 && amount.amount !== undefined) {
          var tempLine = {}; //The details to use in details page
          var tempItem = {}; //The body to send to the api
          const createReceiptLines =
            constantURI() +
            "CreateReceiptLines?token=" +
            this.state.token +
            "&user=" +
            this.state.username +
            "&amount=" +
            amount.amount +
            "&paymentId=" +
            uuid +
            "&account=" +
            amount.accountId +
            "&method=" +
            Number(amount.payType) +
            "&type=" +
            amount.paymentType +
            "&currency=" +
            amount.currenyId[0];

          tempItem.amount = amount.amount;
          tempItem.receiptNum = "RCT-" + uuid;
          tempItem.receipt_amount = amount.convertedAmount;
          tempItem.currency_id = amount.currenyId[0];
          tempItem.payment_type_id = amount.payType;
          tempItem.valueDate = new Date().toISOString().substring(0, 10);

          tempLine = amount;
          tempLine.id = uuid;
          tempLine.URL = createReceiptLines;

          temp.Lines.push(tempLine);
          tempBody.lines.push(tempItem);
        }
      });
    }
    temp.Body = tempBody;

    //Define the invoices of the transaction
    // temp.Invoices = [];
    // if (this.state.invoices.length !== 0) {
    //   await this.state.invoices.map((invoice) => {
    //     var tempLine = {};
    //     const createReceiptInvoices =
    //       constantURI() +
    //       "CreateTransReceipt?token=" +
    //       this.state.token +
    //       "&user=" +
    //       this.state.username +
    //       "&moveId=" +
    //       invoice.id +
    //       "&amount=" +
    //       invoice.amountToPay +
    //       "&paymentId=" +
    //       uuid;
    //     const updateInvoice =
    //       constantURI() +
    //       "UpdateInvoice?token=" +
    //       this.state.token +
    //       "&user=" +
    //       this.state.username +
    //       "&id=" +
    //       invoice.id +
    //       "&amount=" +
    //       (invoice.amount_total -
    //         invoice.amount_residual +
    //         Number(invoice.amountToPay));
    //     tempLine = invoice;
    //     tempLine.id = uuid;
    //     tempLine.URL = createReceiptInvoices;
    //     tempLine.UpdateURL = updateInvoice;

    //     temp.Invoices.push(tempLine);
    //   });
    // }
    //Set this transaction and the count in the local storage

    temp.Invoices = [];
    if (this.state.invoices.length !== 0) {
      await this.state.invoices.map((invoice) => {
        var tempLine = {};
        const updateInvoice =
          constantURI() +
          "UpdateInvoice?token=" +
          this.state.token +
          "&user=" +
          this.state.username +
          "&id=" +
          invoice.id +
          "&amount=" +
         (
  Number(invoice.amount_total) -
  Number(invoice.amount_residual) +
  Number(invoice.amountToPay)
).toFixed(2)
        tempLine = invoice;
        tempLine.id = uuid;
       
        tempLine.UpdateURL = updateInvoice;

        temp.Invoices.push(tempLine);
      });
    }
    await payments.push(temp);
    const nextCount = this.state.count + 1;
    const localCount = [...(this.state.originalCount || [])];
    localCount[this.state.currentType] = nextCount;
    this.setState({ count: nextCount, originalCount: localCount });
    const localSOs = this.state.originalPayments;
    localSOs[this.state.currentType] = payments;
    await localStorage.setItem(
      "UnsyncedTransactionsCount",
      JSON.stringify(localCount)
    );
    await localStorage.setItem(
      "UnsyncedTransactions",
      JSON.stringify(localSOs)
    );
    await this.DailySummaryReport();
    this.clearPendingCashInvoicePayment();
    // await this.showPrint();
    await this.props.history.push("/Receipt");
  };

  onSave = async () => {
    if (this.sign.current.isEmpty()) {
      alert("Please sign this payment");
      return;
    }

    const uuid = uuidv4();
    this.setState({ signature: this.sign.current.toDataURL() });
    const paymentCurrency = this.getCurrentPaymentCurrency();

    if (this.state.currentType === 3) {
      if (this.state.invoices.length !== 0) {
        for (const invoice of this.state.invoices) {
          const createReceipt =
            constantURI() +
            "CreateNewReceipt?token=" +
            this.state.token +
            "&user=" +
            this.state.username +
            "&partnerId=" +
            this.state.clientId +
            "&name=" +
            "RCT-" +
            this.state.user[0].user_code +
            "-" +
            uuid +
            "&userId=" +
            this.state.user[0].id +
            "&currencyId=" +
            paymentCurrency[0] +
            "&date=" +
            new Date().toISOString().substring(0, 10) +
            "&moveId=" +
            invoice.id +
            "&amount=" +
            invoice.amountToPay +
            "&paymentId=" +
            uuid +
            "&transName=" +
            invoice.name;

          await this.saveOfflineInvoice(createReceipt);
        }
      }
    } else {
      await this.saveOfflineCashInvoice();
    }
    ////If online
    //if (this.state.authenticate) {
    //    await this.saveOnline(createReceipt, uuid);
    //}
    //else {
    //}
  };

  DailySummaryReport = async () => {
    const nextSummary = Array.isArray(this.state.dailySummaryReport)
      ? [...this.state.dailySummaryReport]
      : [];
    if (nextSummary[0] && typeof nextSummary[0] === "object") {
      nextSummary[0] = {
        ...nextSummary[0],
        collection: Number(nextSummary[0].collection || 0) + 1,
      };
    }
    await this.setState({ dailySummaryReport: nextSummary });
    await localStorage.setItem(
      "DailySummaryReport",
      JSON.stringify(nextSummary)
    );
  };

  pad(n, length) {
    //Formating digits
    var len = length - ("" + n).length;
    return (len > 0 ? new Array(++len).join("0") : "") + n;
  }

  //Add another object in the amounts array
  onClickAdd = () => {
    if (this.state.amounts.length === 0) {
      this.setPaymentTypeBeginning();
      return;
    }

    this.setState({ amounts: [...this.state.amounts, {}] });
  };

  //Delete the selected item and set total amount
  onDeleteItem = async () => {
    const newAmounts = [...this.state.amounts];
    newAmounts.splice(this.state.currentIndex, 1);
    await this.setState({ amounts: newAmounts });
    await this.setTotalPaymentAmount();
    await this.calculateRemainingAmountPrimaryCurrency();
    this.closeDeleteAlert();
  };

  closeDeleteAlert = () => {
    this.setState({ showDeleteAlert: false });
  };

  showDeleteAlert = (index) => {
    this.setState({ showDeleteAlert: true, currentIndex: index });
  };

  //calculating the remaining amount the client's currency
  calculateRemainingAmountPrimaryCurrency = async () => {
    if (
      Number(this.state.totalAmount) -
        Number(this.state.totalPayment) >=
      0
    )
      await this.setState({
        remainingAmount: Math.abs(
          Number(this.state.totalAmount - this.state.totalPayment)
        ),
        invalidAmount: false,
      });
    else {
      await this.setState({ invalidAmount: true });
      alert("Amounts entered are greater than the total amount");
    }
  };

  //calculating the remaining amount based on the selected payment type
  calculateRemainingAmountSelectedCurrency = async (index) => {
    const currentEntry = this.state.amounts[index] || {};
    const rate = Number(currentEntry.rate || this.state.primaryRate || 1);
    const primaryRate = Number(this.state.primaryRate || 1);
    const convertedAmount = (rate * this.state.remainingAmount) / primaryRate;
    const nextAmounts = [...this.state.amounts];
    nextAmounts[index] = {
      ...currentEntry,
      amount: Number(convertedAmount),
      convertedAmount: Number(
        ((convertedAmount / rate) * primaryRate).toFixed(this.state.fixed)
      ),
    };

    await this.setState({ amounts: nextAmounts });
    await this.setTotalPaymentAmount();
    await this.calculateRemainingAmountPrimaryCurrency();
  };

  showSignatureAlert = async () => {
    const totalAmount = Number(this.state.totalAmount);
    const totalPayment = Number(this.state.totalPayment);
    //Alert the user if the entered amount is different than the total paid amount
    if (totalAmount > totalPayment || totalAmount < totalPayment) {
      this.setState({ showSignatureAlert: false });
      alert(
        "The amount paid by the client is different than the amount entered."
      );
    } else {
      this.setState({ showSignatureAlert: true });
    }
  };

  closeSignatureAlert = () => {
    this.setState({ showSignatureAlert: false });
  };

  clearSignature = () => {
    this.sign.current.clear();
  };

  render() {
    const paymentCurrency = this.getCurrentPaymentCurrency();
    const exchangeRate =
      Array.isArray(this.state.CurrencyRate) && this.state.CurrencyRate.length > 0
        ? this.state.CurrencyRate[0].RateB1
        : 0;
    const paymentOptions = Array.isArray(this.state.paymentTypes)
      ? this.state.paymentTypes
      : [];
    const rowAmounts = Array.isArray(this.state.amounts) ? this.state.amounts : [];
    if (!this.state.loading) {
      return (
        <div
          className="container-fluid vh-100"
          style={stylesASAP.mainBackgroundColor}
        >
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className={this.state.disableSync ? "btn disabled" : "btn"}
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row pt-3">
            {/* <div className="col">
              <ArrowBackCircle
                className="btn"
                onClick={() => {
                  localStorage.setItem("PendingInvoices", JSON.stringify([]));
                  this.props.history.push(
                    "./" +
                      this.state.transactionTypes[this.state.currentType]
                        .backButton
                  );
                }}
                color={"#00bfff"}
                height="50px"
                width="50px"
              />
            </div> */}
            <div className="col-12 text-center">
              <h1>Payment</h1>
            </div>
            <div className="col d-flex flex-row-reverse">
              <div
                className="btn"
                style={stylesASAP.saveButton}
                onClick={this.showSignatureAlert}
              >
                Save Payment
              </div>
            </div>
          </div>
          <div className="m-4 p-3" style={stylesMed.cardBackgroundColor}>
            <div className="row">
              <p className="col">
                Client Name: <b>{this.state.clientName}</b>
              </p>
            </div>
            <div className="row">
              {/*<div className="col">*/}
              {/*    <div className="row">*/}
              {/*        <p className="col-sm-2 mt-2">Journal:</p>*/}
              {/*        <select className="col-sm-10 form-control" style={stylesASAP.selectWidth} value={this.state.journal}*/}
              {/*            onChange={this.onChangeJournal}>*/}
              {/*            <option value=""></option>*/}
              {/*            {this.state.journals.map((item) => {*/}
              {/*                return (*/}
              {/*                    <option value={item.id}>{item.name}</option>*/}
              {/*                )*/}
              {/*            })*/}
              {/*            }*/}
              {/*        </select>*/}
              {/*    </div>*/}
              {/*</div>*/}
              <p className="col">
                Amount Paid:{" "}
                <b>
                  {this.state.totalAmount + " " + this.getCurrencyDisplayName(paymentCurrency)}
                </b>
              </p>
              <p className="col">
                Remaining Amount:{" "}
                <b>
                  {this.state.remainingAmount.toFixed(this.state.fixed) +
                    " " +
                    this.getCurrencyDisplayName(paymentCurrency)}
                </b>
              </p>
              <p className="col">
                1 USD = <b>{exchangeRate} LBP</b>
              </p>
            </div>
          </div>
          <div>
            {rowAmounts.map((item, index) => {
              return (
                <div
                  className="m-4 p-3 "
                  style={stylesASAP.mainBackgroundColor1}
                >
                  <div className="row">
                    <div className="col form-group mt-1">
                      <label>Payment Type:</label>
                      <select
                        className="form-control"
                        style={stylesASAP.selectWidth}
                        value={this.state.amounts[index].payType}
                        disabled={false}
                        onChange={this.onSelectType(index)}
                      >
                        <option value=""></option>
                        {paymentOptions.map((item) => {
                          return <option value={item.id}>{item.name}</option>;
                        })}
                      </select>
                    </div>
                    <div className="col form-group mt-1">
                      <label>
                        Amount in{" "}
                        {this.getCurrencyDisplayName(this.state.amounts[index].currenyId)}
                        :
                      </label>
                      <input
                        className="form-control"
                        type="number"
                        value={this.state.amounts[index].amount}
                        disabled={
                          this.state.amounts[index].payType !== "" &&
                          this.state.amounts[index].payType !== undefined
                            ? false
                            : true
                        }
                        onChange={this.onChangeAmount(index)}
                        style={stylesASAP.inputWidth}
                        onKeyDown={(e) =>
                          this.state.preventSymbols.includes(e.key) &&
                          e.preventDefault()
                        }
                        min="1"
                      />
                    </div>
                    <div className="col form-group mt-1">
                      <label>Amount in {this.getCurrencyDisplayName(paymentCurrency)}:</label>
                      <p style={stylesASAP.marginTitle}>
                        {this.state.amounts[index].convertedAmount}
                      </p>
                    </div>
                    <div className="col form-group mt-4">
                      <TrashOutline
                        className="col btn"
                        color={"#00bfff"}
                        height="30px"
                        width="30px"
                        onClick={() => this.showDeleteAlert(index)}
                      />
                    </div>
                    <Modal
                      show={this.state.showDeleteAlert}
                      onHide={this.closeDeleteAlert}
                      animation={false}
                    >
                      <Modal.Header>
                        <Modal.Title>
                          Are you sure you want to delete this method?
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div
                          className="btn btn-primary"
                          style={stylesWMS.deleteButtonAlertTransfer}
                          onClick={() => this.onDeleteItem(index)}
                        >
                          Delete
                        </div>
                        <div
                          className="btn btn-danger"
                          style={stylesWMS.cancelButtonAlertTransfer}
                          onClick={() => this.closeDeleteAlert()}
                        >
                          Cancel
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>
                </div>
              );
            })}
          </div>
          <div style={stylesASAP.addButton}>
            <AddCircle
              color={"#00bfff"}
              height="60px"
              width="60px"
              onClick={() => this.onClickAdd()}
            />
            <p>Add Another Payment Method</p>
          </div>
          <div className="m-4 p-3">
            <h2>
              Total:{" "}
              {Number(this.state.totalPayment).toFixed(this.state.fixed) +
                " " +
                this.getCurrencyDisplayName(paymentCurrency)}
            </h2>
          </div>
          <Modal
            show={this.state.showSignatureAlert}
            onHide={this.closeSignatureAlert}
            animation={false}
          >
            <div className="col">
              <ArrowBackCircle
                className=" btn"
                onClick={() => this.closeSignatureAlert()}
                color={"#00bfff"}
                height="50px"
                width="50px"
              />
            </div>
            <Modal.Body className="text-center">
              <h1>Signature</h1>
            </Modal.Body>
            <Modal.Body>
              <div>
                <div>
                  <div className="pt-3 row">
                    <div className="col d-flex flex-row-reverse">
                      <div
                        className="btn"
                        style={stylesASAP.wideButton}
                        onClick={this.onSave}
                      >
                        Save
                      </div>
                      <div
                        className="btn "
                        style={stylesASAP.clearButton}
                        onClick={this.clearSignature}
                      >
                        Clear
                      </div>
                    </div>
                    <hr />
                  </div>
                  <div className="text-center mt-1 ">
                    <SignaturePad
                      className="text-center border"
                      style={stylesASAP.signature}
                      ref={this.sign}
                      options={{
                        minWidth: 3,
                        maxWidth: 3,
                        penColor: "#00bfff",
                      }}
                    />
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <Modal show={this.state.showPrint} animation={false}>
            <Modal.Body>
              <Print history={this.props.history}></Print>
            </Modal.Body>
          </Modal>
        </div>
      );
    } else {
      return (
        <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className="btn"
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="row pt-3">
            <div className="col">
              <ArrowBackCircle
                className="btn"
                onClick={() => {
                  localStorage.setItem("PendingInvoices", JSON.stringify([]));
                  this.props.history.push("./Receipt");
                }}
                color={"#00bfff"}
                height="50px"
                width="50px"
              />
            </div>
            <div className="col mt-2">
              <h1>Payment</h1>
            </div>
            <div className="col d-flex flex-row-reverse">
              <div
                className="btn"
                style={stylesASAP.saveButton}
                onClick={this.onSave}
              >
                Save Payment
              </div>
            </div>
          </div>
          <div className="pt-3 mt-5 text-center">
            <div className="spinner-border" style={stylesASAP.spinner}></div>
          </div>
        </div>
      );
    }
  }
}
